export const DATA_TYPE_EXAMPLES = {
  0: 'Sample Text',              // String
  1: '42',                       // Int
  2: 'Yes / No',                 // Bool
  3: '01/15/2025',               // Date
  4: '01/15/2025 10:30 AM',     // DateTime
  5: 'Option A',                 // LookupType
  6: '123 Main St, City, ST 12345', // Address
  7: 'John Smith',               // Name
  8: '(555) 555-5555',           // PhoneNumber
  9: 'D-1234-1234',              // ImageViewerLink
  10: '000223341',               // ReceiptLink
}

export const LINK_EXAMPLE_DATA_TYPES = new Set([9, 10])

export const HISTORY_FIELDS = [
  'Filing Type', 'Filing Number', 'Received Date', 'Processed Date',
  'DLN', 'Receipt Number', 'Receipt Amount', 'Status', 'Entry Type',
  'Created By User', 'Last Modified By User', 'Processed By User',
]
